export enum Permission {
    /*
    *  Common permissions
    */
    // Read
    CanViewReports = 'CanViewReports', // Reports Page
    // Edit
    CanEditThresholdsAndRecommendations = 'CanEditThresholdsAndRecommendations', // Admin Page
    CanSetReferenceReports = 'CanSetReferenceReports',

    /*
    *  Transformer permissions
    */
    // Read
    CanViewTransformerData = 'CanViewTransformerData',
    CanViewTransformerRecommendations = 'CanViewTransformerRecommendations',
    CanViewTransformerReports = 'CanViewTransformerReports',
    // Edit
    CanEditTransformerRecommendations = 'CanEditTransformerRecommendations',
    CanEditTransformerComments = 'CanEditTransformerComments',
    CanOverrideTransformerConditionStatus = 'CanOverrideTransformerConditionStatus',
    CanSetTransformerAsNoAction = 'CanSetTransformerAsNoAction',
    CanExportTransformerReports = 'CanExportTransformerReports',
    CanExcludeTransformerReports = 'CanExcludeTransformerReports',

    /*
    *  Generator permissions
    */
    // Read
    CanViewGeneratorsData = 'CanViewGeneratorsData',
    CanViewGeneratorRecommendations = 'CanViewGeneratorRecommendations',
    CanViewGeneratorReports = 'CanViewGeneratorReports',
    // Edit
    CanEditGeneratorRecommendations = 'CanEditGeneratorRecommendations',
    CanEditGeneratorComments = 'CanEditGeneratorComments',
    CanOverrideGeneratorConditionStatus = 'CanOverrideGeneratorConditionStatus',
    CanSetGeneratorAsNoAction = 'CanSetGeneratorAsNoAction',
    CanExportGeneratorReports = 'CanExportGeneratorReports',
    CanExcludeGeneratorReports = 'CanExcludeGeneratorReports',
}
